import Address from './Address';
import Modal, { ModalSizes } from '../common/Modal';

const ModalAddress = ({
  addressId,
  setAddresses,
  addresses,
  addressesId = null,
  setAddressesId = null,
  isOpen,
  closeModal,
  inputProvider,
  setInputProvider,
  realAddress = false,
  legalAddress = false,
  countriesParent,
}) => {
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} size={ModalSizes.small} height="auto">
      <Address
        closeModal={closeModal}
        addressId={addressId}
        addresses={addresses}
        setAddresses={setAddresses}
        addressesId={addressesId}
        setAddressesId={setAddressesId}
        inputProvider={inputProvider}
        setInputProvider={setInputProvider}
        realAddress={realAddress}
        legalAddress={legalAddress}
        countriesParent={countriesParent}
      />
    </Modal>
  );
};

export default ModalAddress;
